import { component } from 'picoapp';
import Swiper, { Pagination } from 'swiper';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const sliderElement = node.querySelector('.js-slider');
  const paginationElement = node.querySelector('.js-pagination');

  /**
   * Functions
   */
  const initSlider = () => {
    (() => new Swiper(sliderElement, {
      modules: [Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      pagination: {
        el: paginationElement,
        type: 'bullets',
        bulletClass: 'product-slider__pagination__bullet',
        bulletActiveClass: 'product-slider__pagination__bullet--active',
      },
    }))();
  };

  const init = () => {
    initSlider();
  };

  /**
   * Init
   */
  init();
});
